import TMain from '../templates/main';
import { RailDisplayMode, RailType } from '@shared/types/enums/rail';
import Content from '@shared/types/enums/content';

export default function BackDoor() {
  /* TIVIFY */
  const TivifyProdSamsung = {
    title: 'Tivify Prod',
    eventId: 'https://smarttv.tvup.cloud',
    photo:
      'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
  };
  const TivifyPreprodSamsung = {
    title: 'Tivify Preproduction',
    eventId: 'https://smarttvpreproduction.tvup.cloud/SAMSUNG',
    photo:
      'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
  };
  const TivifyStageSamsung = {
    title: 'Tivify Stage',
    eventId: 'https://smarttvstage.tvup.cloud/SAMSUNG/',
    photo:
      'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
  };

  const TivifyProdLG = {
    title: 'Tivify Prod',
    eventId: 'https://smarttv.tvup.cloud/LG/',
    photo:
      'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
  };
  const TivifyPreprodLG = {
    title: 'Tivify Preproduction',
    eventId: 'https://smarttvpreproduction.tvup.cloud/LG',
    photo:
      'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
  };
  const TivifyStageLG = {
    title: 'Tivify Stage',
    eventId: 'https://smarttvstage.tvup.cloud/LG/',
    photo:
      'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
  };

  /* MundoGo */
  const MundoGoProdSamsung = {
    title: 'MundoGo Prod',
    eventId: 'https://smarttv.tvup.cloud/SAMSUNG/mundogo',
    photo:
      'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
  };
  const MundoGoPreprodSamsung = {
    title: 'MundoGo Preproduction',
    eventId: 'https://smarttvpreproduction.tvup.cloud/SAMSUNG/mundogo',
    photo:
      'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
  };
  const MundoGoStageSamsung = {
    title: 'MundoGo Stage',
    eventId: 'https://smarttvstage.tvup.cloud/SAMSUNG/mundogo',
    photo:
      'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
  };

  const MundoGoProdLG = {
    title: 'MundoGo Prod',
    eventId: 'https://smarttv.tvup.cloud/LG/mundogo',
    photo:
      'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
  };
  const MundoGoPreprodLG = {
    title: 'MundoGo Preproduction',
    eventId: 'https://smarttvpreproduction.tvup.cloud/LG/mundogo',
    photo:
      'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
  };
  const MundoGoStageLG = {
    title: 'MundoGo Stage',
    eventId: 'https://smarttvstage.tvup.cloud/LG/mundogo',
    photo:
      'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
  };

  const SAMSUNG_RAIL = {
    data: [
      TivifyProdSamsung,
      TivifyPreprodSamsung,
      TivifyStageSamsung,
      MundoGoProdSamsung,
      MundoGoPreprodSamsung,
      MundoGoStageSamsung,
    ],
    displayMode: RailDisplayMode.PHOTO,
    title: 'SAMSUNG',
    type: RailType.REGULAR,
  };

  const LG_RAIL = {
    data: [
      TivifyProdLG,
      TivifyPreprodLG,
      TivifyStageLG,
      MundoGoProdLG,
      MundoGoPreprodLG,
      MundoGoStageLG,
    ],
    displayMode: RailDisplayMode.PHOTO,
    title: 'LG',
    type: RailType.REGULAR,
  };
  const rails = [SAMSUNG_RAIL, LG_RAIL];

  rails.forEach((item) => {
    item.data.forEach((item2) => {
      item2.getEpisodeNumber = () => '';
      item2.getSeasonNumber = () => '';
      item2.type = Content.BACK_DOOR;
    });
  });
  return (
    <TMain
      complete={true}
      hideBackground={true}
      message={undefined}
      rails={rails}
      sliders={[]}
      startsInMenu={false}
      startsInSlider={true}
    />
  );
}
